import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTheme } from '../contexts/ThemeContext';
import { setSessionExpiredUI, logoutDueToExpiredSession } from '../utils/auth';
import { checkAppSession } from '../utils/apiFetch';
import '../BottomSheet.css';

const DEFAULT_MESSAGE = 'Session expired. Please login again.';

const SessionExpiredDialog = () => {
  const { isDarkMode } = useTheme();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(DEFAULT_MESSAGE);

  useEffect(() => {
    const show = (nextMessage) => {
      setMessage(nextMessage || DEFAULT_MESSAGE);
      setOpen(true);
    };

    setSessionExpiredUI(show);
    return () => {
      setSessionExpiredUI(null);
    };
  }, []);

  useEffect(() => {
    const recheck = () => {
      if (document.visibilityState && document.visibilityState !== 'visible') {
        return;
      }
      if (!localStorage.getItem('authToken')) {
        return;
      }
      checkAppSession();
    };

    document.addEventListener('visibilitychange', recheck);
    window.addEventListener('pageshow', recheck);
    window.addEventListener('focus', recheck);
    return () => {
      document.removeEventListener('visibilitychange', recheck);
      window.removeEventListener('pageshow', recheck);
      window.removeEventListener('focus', recheck);
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <div
      className={`success-alert-overlay ${isDarkMode ? 'dark-theme' : 'light-theme'}`}
      data-theme={isDarkMode ? 'dark' : 'light'}
    >
      <div className="success-alert-box" role="alertdialog" aria-modal="true" aria-labelledby="session-expired-title">
        <div className="success-alert-icon-wrap">
          <ErrorOutlineIcon className="success-alert-icon session-expired-icon" />
        </div>
        <Typography id="session-expired-title" variant="h6" className="success-alert-title">
          Session expired
        </Typography>
        <Typography className="success-alert-message">{message}</Typography>
        <Button
          variant="contained"
          className="success-alert-btn"
          onClick={() => logoutDueToExpiredSession(message)}
          fullWidth
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default SessionExpiredDialog;
